import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from '@mui/material';
import React from 'react';

const ReactionFilter = ({ originalTargets, selectedTargets, setSelectedTargets, title }) => {
	const handleChange = event => {
		const { value } = event.target;
		setSelectedTargets(typeof value === 'string' ? value.split(',') : value);
	};

	// Format selected values into a comma-separated string for display
	const formatSelectedValues = values => values.join(', ');

	return (
		<div className="instructor-select-section">
			{originalTargets.length > 0 && (
				<div className="instructor-filter">
					<FormControl sx={{ width: 300 }}>
						<InputLabel id={`${title}-select-label`}>{title}</InputLabel>
						<Select
							labelId={`${title}-select-label`}
							multiple
							value={selectedTargets}
							onChange={handleChange}
							input={<OutlinedInput label={title} />}
							renderValue={formatSelectedValues}
						>
							{originalTargets.map(target => (
								<MenuItem key={target._id} value={target.name}>
									<Checkbox checked={selectedTargets.indexOf(target.name) > -1} />
									<ListItemText primary={target.name} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>
			)}
		</div>
	);
};

export default ReactionFilter;
